export default __webpack_public_path__ + "static/media/kitchenwares_study_naples_yellow.f607f750.jpg";